import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={article.cover}
            alt={`${article.title} - 动漫网`}
            title={`${article.title} - 动漫网`}
            loading="lazy"
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
            {article.category}
          </span>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="line-clamp-2 text-sm font-semibold text-foreground-900 transition group-hover:text-primary-700 md:text-base">
            {article.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-xs text-foreground-600 md:text-sm">{article.summary}</p>
          <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {(article.views / 1000).toFixed(1)}k
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}